import { FILTER_TYPES } from "@/config/filters";
import { i18n } from "@/plugins/i18n";

export class Filter {

  constructor(data, type) {
    this.id = data.id
    this.name = data.name

    this.type = type

    this.isActive = false
    this.disabled = false
  }

  setIsActiveState(isActive) {
    this.isActive = isActive
  }

}

export class BuilderFilter extends Filter {
  constructor(data) {
    super(data, FILTER_TYPES.BUILDER);
  }
}

export class EpochFilter extends Filter {
  constructor(data) {
    const periodLabel = [
      data.from || i18n.t('header.filters.epoch.noStartYearLabel'),
      data.to || (new Date).getFullYear()
    ].join(' - ')

    super({
      id: data.id,
      name: data.name ? `${ data.name } (${ periodLabel })` : periodLabel
    }, FILTER_TYPES.EPOCH)

    this.from = data.from
    this.to = data.to
    this.periodLabel = periodLabel
    this.imagesCount = data.images_count
  }
}

export class RegionFilter extends Filter {
  constructor(data) {
    super(data, FILTER_TYPES.REGION);
  }
}

export class StreetFilter extends Filter {
  constructor(data) {
    super(data, FILTER_TYPES.STREET);
  }
}

export class TypeFilter extends Filter {
  constructor(data) {
    super(data, FILTER_TYPES.TYPE);
  }
}

export class FocusFilter extends Filter {
  constructor(data) {
    super(data, FILTER_TYPES.FOCUS);
  }
}

export default {
  Filter,
  BuilderFilter,
  EpochFilter,
  RegionFilter,
  StreetFilter,
  TypeFilter,
  FocusFilter
}
